<template>
  <div class="wt-slider wt2-sg -custom-css">
    <wt-slider
      :value="sliderValue"
      :min="field.minValue"
      :max="field.maxValue"
      :steps="field.options"
      :disabled="field.disabled"
      @change="changeSliderValue"
    >
      <div slot="header">
        <span v-if="field.label">{{ field.label }}</span>
        <slot name="tooltip"></slot>
      </div>
      <div slot="input-box-holder" class="-lock-holder">
        <div
          v-if="allowStoryboardingControls"
          @click="lockUnlockStoryboardField"
          class="-lock-icon"
        >
          <i
            class="wticon wticon-unlocked"
            title="Lock Field for Editing"
            v-if="isStoryboardFieldEditable"
          />
          <i
            class="wticon wticon-locked"
            title="Unlock Field for Editing"
            v-else
          />
        </div>
      </div>
      <div slot="footer">
        <span>{{ sliderValue }}</span>
      </div>
    </wt-slider>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(
          ['minValue', 'maxValue', 'options', 'defaultValue'],
          (prop) => _.includes(_.keys(value), prop)
        );
      },
    },
    fieldDataModel: {
      type: Object,
      required: false,
    },
    allowStoryboardingControls: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  mixins: [fieldsMixin],

  data() {
    return {
      sliderValue: null,
      isFirstUpdate: null,
    };
  },

  created() {
    this.sliderValue = _.isDefined(this.field.value)
      ? this.field.value
      : this.field.defaultValue;
    this.emitChange({ newValue: this.sliderValue, makeDirty: false });
    this.$watch('sliderValue', (newValue) => {
      this.emitChange({ newValue, makeDirty: !this.isFirstUpdate });
    });
  },

  mounted() {
    this.fieldReadyNextTick();
  },

  computed: {
    isStoryboardFieldEditable() {
      return this.fieldDataModel ? this.fieldDataModel.editable : true;
    },
  },

  methods: {
    lockUnlockStoryboardField() {
      this.$emit('storyboardingControlsChanged', {
        name: 'editable',
        value: !this.isStoryboardFieldEditable,
      });
    },
    changeSliderValue(sliderValue) {
      this.isFirstUpdate = this.isFirstUpdate === null;
      this.sliderValue = sliderValue;
    },
  },
};
</script>

<style scoped lang="scss">
.-header-right-area {
  position: relative;
}
.wt2-slider {
  padding-bottom: 0;
}
.-lock-holder {
  position: relative;
  width: 17px;
  font-size: 17px;
  margin-left: 15px;
}
</style>
